import { Injectable } from '@angular/core';
import { TypeDataCopy } from 'app/components/modules/root/management-data/models/type-data-copy';
import { HttpService, MessageService, params } from 'brainloper-ui';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { Question } from 'app/models2/inspections/question';

@Injectable({
  providedIn: 'root',
})
export class InformationHandlerService {
  constructor(
    private http: HttpService,
    private msm: MessageService) {}

  public async copyData(
    compania_obt_info,
    compania_envia_info,
    params: TypeDataCopy
  ) {
    ///funcion copyData que toma la informacion de formulario, params:la tabla a enviar array, donde esta id,name.url1,url2, parmas
    try {
      this.msm.openLoading('Cargando', 'Cargando...');
      let ok: boolean = true;
      var mens: string = 'La informacion se ha enviado correctament';
      var resc1: BaseResponse<any> = await this.http.getDataPromise(
        params.urlGet,
        params.params
      ); //datos de la compañia guardados en la variable resc1
      if (resc1.code === 0) {
        for (let element of resc1.body) {
          if (params.urlDetalle) {
            var detalle: BaseResponse<any> = await this.http.getDataPromise(
              `${params.urlDetalle}/${element.id}`
            );
            if (detalle.code === 0) {
              element = detalle.body[0];
            } else {
              this.msm.Error('Error', detalle.message);
            }
          }
          element.id_compania = compania_envia_info;
          let resp: BaseResponse<GenericResponse> = await this.http.postDataPromise(
            params.urlPost,
            element
          );
          try {
            if (resp.code != 0) {
              ok = false;
              mens = resp.message;
              console.error(resp.message);
            }
          } catch (error) {
            console.error(error);
          }
        }
        if (ok) {
          this.msm.closeLoading();
          this.msm.Success('Ok', mens);
        } else {
          this.msm.closeLoading();
          this.msm.Error('Error', mens);
        }
      } else {
        this.msm.closeLoading();
        this.msm.Error('Error', 'Error obteniendo información');
      }
    } catch (error) {
      this.msm.closeLoading();
      console.error('copyData', error);
    }
  }

  public async createPreopResoponce(
    id_compania: number,
    urlPreo: string,
    urlPreoP: string
  ) {
    this.msm.openLoading('cargando', 'creando respuestas');
    let ok: boolean = true;
    var mens: string = 'La informacion se ha enviado correctament';
    let params: params[] = [{ id: 'id_compania', value: id_compania }];
    let respuesta: BaseResponse<any> = await this.http.getDataPromise(
      urlPreo,
      params
    );
    if (respuesta.code === 0) {
      for (let element of respuesta.body) {
        let s = element.tipo_respuesta as string;
        let broken = s.split('/');
        for (const resp of broken) {
          let respuesta = {
            id_tipo_respuesta: element.id,
            respuesta: resp.trim(),
            id_compania: id_compania,
          };
          let respPos: BaseResponse<GenericResponse> = await this.http.postDataPromise(
            urlPreoP,
            respuesta
          );
          try {
            if (respPos.code != 0) {
              ok = false;
              mens = respPos.message;
              this.msm.closeLoading();
              console.error(respPos.message);
            }
          } catch (error) {
            this.msm.closeLoading();
            console.error(error);
          }
        }
      }
      if (ok) {
        this.msm.closeLoading();
        this.msm.Success('Ok', mens);
      } else {
        this.msm.closeLoading();
        this.msm.Error('Error', mens);
      }
    } else {
      this.msm.closeLoading();
      this.msm.Error('Error', 'Error obteniendo respuesta');
    }
  }

  public async CreateQuestions(
    companiaGetInfo: number,
    companiaSendInfo: number,
    equipmentTypeFromId: number,
    equipmentTypeToId: number,
    paramsQuestions: TypeDataCopy
  ) {
    this.msm.openLoading("Cargando", "Cargando...")
    let questionsCompaniaFrom: Array<Question>= [];

    try {

      questionsCompaniaFrom = await this.getData(companiaGetInfo, paramsQuestions)
    
      if(questionsCompaniaFrom.length > 0){

        for(let element of questionsCompaniaFrom as Array<Question>){
          let body:Question  = {
            responseTypeId: element.responseTypeId,
            question : element.question
          }
          await this.http.postDataPromise(paramsQuestions.urlPost, body)
        }
        this.msm.closeLoading()
      }else{
        this.msm.closeLoading()
        this.msm.Warning('Datos vacios', 'no hay datos a tranferir');
      }
    } catch (error) {
      this.msm.closeLoading()
      console.error('CreateQuestions', error);
    }
  }

  public async getData(
    companiaId: number,
    paramsResponseType: TypeDataCopy
  ) {
    try {
      let response: Array<any> = [];
      paramsResponseType.params[0].value = companiaId;
      let res: BaseResponse<any> = await this.http.getDataPromise(
        paramsResponseType.urlGet,
        paramsResponseType.params
      );
      if (res.code === 0) {
        response = res.body;
        return response;
      } else {
        this.msm.Error('Error', res.message);
        return response;
      }
    } catch (error) {
      console.error(error)
    }

  }



}
